import kaplay from "kaplay";
import { crossFadeGo, loadShaders } from "./shaders";
import fusionPixel from './assets/fonts/fusion-pixel-10px-monospaced-zh_hans.ttf'
import fusionPixelDev from '../scripts/fusion-pixel-10px-monospaced-zh_hans.ttf'
import { COLORS } from "./colors";
import nipplejs, { JoystickManager } from 'nipplejs';
import { addDialog, getDefaultTextStyles } from "./text";
import { playBgm } from "./sound";

let joystick: JoystickManager | null = null

export const mainGame = () => {

  const fontUrl = import.meta.env.DEV ? fusionPixelDev : fusionPixel

  const k = kaplay({
    background: COLORS.background,
    font: "FusionPixel",
    crisp: true,
    scale: 1.5,
    debug: import.meta.env.DEV,
  });

  k.loadAseprite("white", "merry/white.png", "merry/white.json")
  k.loadAseprite("shin", "merry/shin_anim.png", "merry/shin_anim.json")

  k.loadFont("FusionPixel", fontUrl)

  loadShaders(k)

  // k.loadSprite("shin", "/merry/shin.png");
  k.loadSprite("tree", "/merry/tree.png");
  k.loadSprite("bean", "/sprites/bean.png");
  k.loadSprite("grass", "/merry/grass.png");
  k.loadSprite("coin", "/sprites/coin.png");
  k.loadSound("pickup_coin", "/sounds/pickup_coin.wav");
  k.loadSound("win_sound", "/sounds/gamestart-272829.mp3");
  k.loadSound("bean_voice", "/sounds/bean_voice.wav");
  k.loadSound("bgm", "/sounds/merry.m4a");

  k.scene("main", () => {
    const SPEED = 360;
    let dir = 0
    const createJoyStick = () => {
      joystick?.destroy()
      joystick = nipplejs.create({
        size: 256,
        mode: 'semi',
        color: '#dd1b30',
      })
      joystick.on('dir:left', (res) => {
        console.log('dir', res)
        dir = -1
      })
      joystick.on('dir:right', (res) => {
        console.log('dir', res)
        dir = 1
      })
      joystick.on('dir:up', (res) => {
        if (player.isGrounded()) {
          player.jump();
        }
      })
      joystick.on('end', (res) => {
        console.log('end', res)
        dir = 0
      })
    }

    createJoyStick()

    const dialog = addDialog(k);

    const baseY = k.height() - 128

    k.setGravity(2400);

    const level = k.addLevel([
      "@  = $$ $$$ $ $$$  W   T",
      "========================",
    ], {
      tileWidth: 64,
      tileHeight: 64,
      pos: k.vec2(k.center().x, baseY),
      tiles: {
        "@": () => [
          k.sprite("shin"),
          k.area(),
          k.body({
            jumpForce: 700,
          }),
          k.anchor("bot"),
          "player",
        ],
        "W": () => [
          k.sprite("white"),
          k.body({ isStatic: true }),
          k.area(),
          k.anchor("bot"),
          k.scale(0.8),
          "white",
        ],
        "=": () => [
          k.sprite("grass"),
          k.area(),
          k.body({ isStatic: true }),
          k.anchor("bot"),
        ],
        "$": () => [
          k.sprite("coin"),
          k.area(),
          k.anchor("bot"),
          k.scale(0.7),
          "coin",
        ],
        "T": () => [
          k.sprite("tree"),
          k.area(),
          k.body({ isStatic: true }),
          k.anchor("bot"),
          k.scale(2),
          k.shader('shake', () => ({
            'u_time': k.time(),
            'u_resolution': k.vec2(10, 10)
          })),
          "tree",
        ],
      },
    });

    const player = level.get("player")[0];
    const white = level.get("white")[0];

    player.play("stand")

    white.play("talk")

    player.onUpdate(() => {
      if (dialog.active()) return;
      // Set the viewport center to player.pos
      k.camPos(player.worldPos());
    });

    // Set the viewport center to player.pos whenever their physics are resolved
    player.onPhysicsResolve(() => {
      if (dialog.active()) return;
      k.camPos(player.worldPos());
    });

    player.onCollide("coin", (coin) => {
      // It does these things
      k.destroy(coin);
      k.play("pickup_coin");
      k.shake(1)
    });


    player.onCollide("white", (w) => {
      k.camScale(1)
      joystick.destroy()
      dir = 0
      dialog.say("[p]圣诞节快乐！\n\n我在前面准备了🎄给你，快过去领取🎁吧！[/p]", "white", true, () => {
        player.play('stand')
        k.camScale(3)
        createJoyStick()
      })
      k.destroy(w)
    });

    let finished = false
    player.onCollide("tree", (w) => {
      k.play("win_sound")
      k.camScale(1)
      joystick.destroy()
      dialog.say("[p]Merry Christmas to Y！\n这是你的礼物：\n\n凭此截图，可完成你的一个愿望。 [/p]", "tree", false)
      finished = true
    });

    k.onMousePress(() => {
      if (!finished && dialog.active()) {
        dialog.dismiss()
      }
    })

    k.camScale(3)

    k.onKeyPress("space", () => {
      if (player.isGrounded()) {
        player.jump();
      }
    });


    k.onUpdate(() => {
      if (dialog.active()) return
      player.flipX = dir === -1;
      player.move(dir * SPEED, 0)
      if (player.isGrounded()) {
        if (dir !== 0) {
          if (player.isGrounded() && player.curAnim() !== "walk") {
            player.play("walk");
          }
        } else {
          player.play("stand");
        }
      } else {
        player.play("jump");
      }

      if (k.camPos().y > 3000) {
        k.go('main')
      }
    })
    k.onKeyDown("left", () => {
      player.flipX = true;
      if (player.isGrounded() && player.curAnim() !== "walk") {
        player.play("walk");
      }
      player.move(-SPEED, 0)
    });
    k.onKeyDown("right", () => {
      player.flipX = false;
      if (player.isGrounded() && player.curAnim() !== "walk") {
        player.play("walk");
      }
      player.move(SPEED, 0)
    });
    k.onKeyRelease(['left', 'right'], () => {
      player.play("stand")
    })

    k.usePostEffect('snowflake', () => ({
      'u_time': k.time(),
      'u_resolution': k.vec2(k.width(), k.height()),
      'u_wind': k.vec2(8, -8)
    }))
  })

  k.scene('menu', () => {
    const white = k.add([
      k.sprite('white'),
      k.pos(k.width() / 2, k.height() / 2),
      k.scale(4),
      k.anchor('center')
    ])

    white.play('talk')

    k.add([
      k.text("[p]Merry\nChristmas\nto\nY![/p]", {
        align: 'center',
        letterSpacing: 1,
        lineSpacing: 8,
        size: 96,
        styles: getDefaultTextStyles(k),
        transform: (idx) => ({
          pos: k.vec2(0, k.wave(-4, 4, k.time() * 4 + idx * 0.5)),
          scale: k.wave(1, 1.2, k.time() * 3 + idx),
        })
      }),
      k.pos(k.width() / 2, k.height() / 5),
      k.anchor('center'),
    ])

    k.add([
      k.text("[p]点击开始[/p]", {
        letterSpacing: 1,
        size: 48,
        styles: getDefaultTextStyles(k),
        transform: () => ({
          opacity: k.wave(0, 1, k.time() * 6)
        })
      }),
      k.pos(k.width() / 2, k.height() - 256),
      k.anchor('center'),
    ])

    const toMain = () => {
      crossFadeGo(k, 'main' as any)
    }
    k.onClick(() => {
      playBgm(k)
      toMain()
    })
  })

  k.go('menu')
}